import React, { useState, useEffect } from "react";
import DriversNavigation from "../../components/Navbar/navbar";
import AuthenticateDriverModal from "../modals/authenticate";
import TransactionSuccessfulModal from "../modals/transactionS";
import Form from "react-bootstrap/Form";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { MdOutlineCancel } from "react-icons/md";
import { Select } from "antd";
import Spinner from "react-bootstrap/Spinner";
import { switchEndpoint } from "../../../../../redux/actions/endpoints";
import axios from "axios";
import { toast } from "react-toastify";
import { storage } from "../../../../../scopedStorage";

const ReviewTransaction = () => {
  const pickUpDetails = JSON.parse(localStorage.getItem("pickUp"));
  // const pickUpDetails = JSON.parse(localStorage.getItem("initiate"));
  const pickUpDetail = JSON.parse(localStorage.getItem("pickUp"));
  const initiateDetails = JSON.parse(localStorage.getItem("initiate"));
  const userDetails = JSON.parse(localStorage.getItem("user"));
  // console.log(userDetails);
  // console.log(pickUpDetail);
  const [showAuth, setShowAuth] = useState(false);
  const handleCloseAuth = () => setShowAuth(false);
  const handleShowAuth = () => setShowAuth(true);

  const [showSuccess, setShowSuccess] = useState(false);
  const handleCloseSuccess = () => setShowSuccess(false);
  const handleShowSuccess = () => setShowSuccess(true);

  const [bankCode, setBankCode] = useState("");
  const [bankAcct, setBankAcct] = useState("");
  const [bankResultStatus, setBankResultStatus] = useState("");
  const [bankResult, setBankResult] = useState(null);
  const [isBankLoading, setIsBankLoading] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleDataChange = (data) => {
    setBankCode(data);
  };

  const getBank = () => {
    setLoading(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/financial-services/banks`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const sortedBanks = [...response.data].sort((a, b) =>
          a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
        );
        setBankList(sortedBanks);
        // setBankList(response.data);
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
        setLoading(false);
      });
  };

  const validateBank = (code, acct) => {
    setIsBankLoading(true);
    const token = storage.getItem("token");
    const payload = {
      bank_code: code,
      account_number: acct,
    };
    axios
      .post(
        `${switchEndpoint}/financial-services/search-external-bank`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        setBankResult(response.data);
        setBankResultStatus(response?.status);
        setIsBankLoading(false);
      })
      .catch((error) => {
        setBankResultStatus(error?.status);
        setIsBankLoading(false);
      });
  };

  useEffect(() => {
    if (bankCode && bankAcct?.length === 10) {
      setBankResult(null);
      validateBank(bankCode, bankAcct);
    } else {
      setBankResult(null);
      setBankResultStatus(null);
    }
  }, [bankCode, bankAcct]);

  // const bankList = [];

  useEffect(() => {
    getBank();
  }, []);

  return (
    <div>
      <DriversNavigation />
      <div className="mx-3">
        <p style={{ fontSize: "16px", fontWeight: "500" }} className="py-3">
          Review
        </p>

        {pickUpDetail?.payment_method === "cash" ||
        pickUpDetails?.payment_method === "cash" ? (
          <div>
            <div>
              <Form>
                <Form.Label htmlFor="selectBank">Select Bank</Form.Label>
                <Select
                  showSearch
                  className="large-select"
                  style={{
                    width: "100%",
                    fontSize: "16px", // Increase font size
                  }}
                  dropdownStyle={{
                    fontSize: "14px", // Ensure dropdown items match the input size
                  }}
                  placeholder="Select a Bank"
                  optionFilterProp="children"
                  onChange={handleDataChange}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  <Select.Option value="">Select Bank</Select.Option>
                  {bankList.map((center) => (
                    <Select.Option key={center.code} value={center.code}>
                      {center.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form>
            </div>
            <div className="mt-4">
              <Form>
                <Form.Label htmlFor="accountNumber">Account Number</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type="text"
                    id="accountNumber"
                    className="py-4"
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      setBankAcct(value);
                    }}
                  />
                  {bankResultStatus === 200 && (
                    <IoIosCheckmarkCircleOutline
                      size={24}
                      color="#c4da00"
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        // color: '#6c757d'
                      }}
                    />
                  )}

                  {bankResultStatus === 400 && (
                    <MdOutlineCancel
                      size={24}
                      color="#FF383C"
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        // color: '#6c757d'
                      }}
                    />
                  )}
                </div>
              </Form>
            </div>
            <div className="d-flex justify-content-between px-4">
              <div />
              <div>
                {isBankLoading ? (
                  <Spinner
                    animation="border"
                    size="sm"
                    className="mt-2"
                    style={{ color: "#c4da00" }}
                  />
                ) : (
                  <div className="mt-2">
                    {bankResultStatus === 200 && <p>{bankResult}</p>}
                    {bankResultStatus === 400 && (
                      <p style={{ color: "#FF383C", fontWeight: "500" }}>
                        Account Not Found
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="mt-5">
              <button
                type="button"
                className="btn greenBtn btn-sm btn-block"
                onClick={() => {
                  // if (!bankCode && !bankAcct && bankResultStatus === 400) {
                  // console.log(true);
                  if (!bankResultStatus || bankResultStatus === 400) {
                    toast.error("Please verify your bank to proceed", {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      pauseOnHover: true,
                      progress: undefined,
                      theme: "light",
                    });

                    return;
                  } else {
                    handleShowAuth();
                  }
                  // }
                }}
                // disabled={loading}
              >
                Transfer
              </button>
            </div>
          </div>
        ) : (
          <div className="cardss py-5">
            <div className="d-flex align-items-center">
              <p className="mb-0">From: </p>
              <p className="mb-0 ml-2">{`${userDetails?.customer?.account?.first_name} ${userDetails?.customer?.account?.last_name}`}</p>
            </div>
            <hr style={{ background: "#F8FA82" }} />

            <div className="d-flex align-items-center">
              <p className="mb-0">To: </p>
              <p className="mb-0 ml-2">{pickUpDetails?.owner?.name}</p>
            </div>
            <hr style={{ background: "#F8FA82" }} />

            <div className="d-flex align-items-center">
              <p className="mb-0">Total Weight: </p>
              <p className="mb-0 ml-2">
                {pickUpDetails
                  ? `${pickUpDetails?.pickup_details?.total_kg}kg`
                  : `${pickUpDetail?.pickup_details?.total_kg}kg`}
              </p>
            </div>
            <hr style={{ background: "#F8FA82" }} />

            <div className="d-flex align-items-center">
              <p className="mb-0">Amount: </p>
              <p className="mb-0 ml-2">
                {pickUpDetails
                  ? `₦${pickUpDetails?.pickup_details?.total_price}`
                  : `₦${pickUpDetail?.pickup_details?.total_price}`}
              </p>
            </div>
            <hr style={{ background: "#F8FA82" }} />

            <div className="d-flex align-items-center">
              <p className="mb-0">Deduction: </p>
              <p className="mb-0 ml-2">
                {pickUpDetails
                  ? `₦${pickUpDetails?.pickup_details?.total_deduction}`
                  : `₦${pickUpDetail?.pickup_details?.total_deduction}`}
              </p>
            </div>
            <hr style={{ background: "#F8FA82" }} />

            <div className="d-flex align-items-center">
              <p className="mb-0">
                Total Debit:{" "}
                {pickUpDetails
                  ? `₦${pickUpDetails?.pickup_details?.total_price}`
                  : `₦${pickUpDetail?.pickup_details?.total_price}`}
              </p>
              <p className="mb-0 ml-2"></p>
            </div>

            <div className="mt-5">
              <button
                type="button"
                className="btn greenBtn btn-sm btn-block"
                onClick={() => {
                  handleShowAuth();
                }}
                // disabled={loading}
              >
                Transfer
              </button>
            </div>
          </div>
        )}
      </div>

      <AuthenticateDriverModal
        showAuth={showAuth}
        handleCloseAuth={handleCloseAuth}
        handleShowSuccess={handleShowSuccess}
        bankCode={bankCode}
        bankResult={bankResult}
        bankAcct={bankAcct}
      />

      <TransactionSuccessfulModal
        showSuccess={showSuccess}
        handleCloseSuccess={handleCloseSuccess}
      />
    </div>
  );
};

export default ReviewTransaction;
